import React from "react";
import ReactDOM from "react-dom";
// import 'intro.js/themes/introjs-nazanin.css';
// import 'intro.js/themes/introjs-dark.css';
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
// import "@reach/slider/styles.css";
import "./i18n";
import history from "./helpers/history";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import store from "./store";
// CoachMarks
import "intro.js/introjs.css";
import "intro.js/themes/introjs-modern.css";
import "toastr/build/toastr.min.css";
import "./index.css";
import "./styles/index.scss";

// reCAPTCHA Enterprise: load enterprise.js (via grecaptcha.enterprise) instead of
// the classic api.js. Our site key is an Enterprise key, so the classic widget
// surfaces a "v1beta1 is deprecated" notice. Must be set before any <ReCAPTCHA>
// mounts. See react-google-recaptcha recaptcha-wrapper getURL().
(
  window as unknown as { recaptchaOptions?: { enterprise: boolean } }
).recaptchaOptions = { enterprise: true };

const app = (
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
    <div
      id="custom-plug"
      style={{
        bottom: "20px",
        height: "1px",
        position: "fixed",
        right: "20px",
        width: "1px",
        visibility: "hidden",
      }}
    ></div>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));
serviceWorker.unregister();
